import React from 'react';
import { useMode } from '../contexts/ModeContext';
import './ModeToggle.css';

function ModeToggle() {
  const { isSimpleMode, isAdvancedMode, toggleMode } = useMode();

  return (
    <div className="mode-toggle-container">
      <div className="mode-toggle">
        <button
          className={`mode-option ${isSimpleMode ? 'active' : ''}`}
          onClick={isAdvancedMode ? toggleMode : undefined}
          disabled={isSimpleMode}
          title="Simple Mode - Personal Finance"
        >
          <span className="mode-icon">🏠</span>
          <span className="mode-label">Simple</span>
        </button>
        
        <button
          className={`mode-option ${isAdvancedMode ? 'active' : ''}`}
          onClick={isSimpleMode ? toggleMode : undefined}
          disabled={isAdvancedMode}
          title="Advanced Mode - Multi-Entity Platform"
        >
          <span className="mode-icon">🏢</span>
          <span className="mode-label">Advanced</span>
        </button>
        
        <div className={`mode-slider ${isAdvancedMode ? 'advanced' : 'simple'}`} />
      </div>
      
      <div className="mode-description">
        {isSimpleMode ? (
          <span className="mode-desc-text">Personal Finance</span>
        ) : (
          <span className="mode-desc-text">Multi-Entity Platform</span>
        )}
      </div>
    </div>
  );
}

export default ModeToggle; 